import { IEventEnrollment } from '../../../../../store/admin/eventEnrollments/store';

export const enrollmentIncludesSeachValue = (enrollment: IEventEnrollment, searchValue: string) => {
  const upperCaseSearchString = searchValue.toUpperCase();

  const {
    user: { firstName, lastName, email }
  } = enrollment;

  return (
    firstName.toUpperCase().includes(upperCaseSearchString) ||
    lastName.toUpperCase().includes(upperCaseSearchString) ||
    email.toUpperCase().includes(upperCaseSearchString)
  );
};
